module.exports = __webpack_public_path__ + "static/media/green-circle@3x.e28bea73.png";